<template>
    <div class="page-container">
        <div class="labelLoader" v-show="!this.label.isReady">
            <div class="cssload-loader">
                <div class="cssload-inner cssload-one"></div>
                <div class="cssload-inner cssload-two"></div>
                <div class="cssload-inner cssload-three"></div>
            </div>
        </div>
        <div class="product-single">
            <div :class="label.preview_type +' previewContainer product-images'">
                <a href="javascript:void(0)" class="prev">{{this.$store.getters.strings.previewText}}</a>
                <app-preview :label="label"></app-preview>
                <background-colors v-show="parseInt(this.label.allow_change_background)" :label="label" :backgroundcolors="label.backroundcolors"></background-colors>
                <div class="startDesign">{{this.$store.getters.strings.startDesign}}</div>
                <div v-bind:class="'previewMessage '+'previewMessage'+this.label.uniqueId"><span>{{this.$store.getters.strings.alertCutMessage}}</span></div>
            </div>
            <div class="product-description option-counter">
                <h1 v-if="!parseInt(combideal_product)" class="product-name">{{this.$store.getters.strings.productName}}</h1>
                <div v-html="this.$store.getters.strings.productDescription"></div>
                <app-editlabel :label="label"></app-editlabel>
            </div>
            <div id="textArea"></div>
        </div>
    </div>
</template>
<script>
    import Preview from './Preview';
    import BackgroundColors from './BackgroundsColors/BackgroundColors';
    import EditLabel from './EditLabel';


    export default {
        data() {
            return {
                combideal_product: window.combideal_product,
            }
        },
        props: ['label'],
        components: {
            appEditlabel: EditLabel,
            appPreview: Preview,
            BackgroundColors: BackgroundColors,
        },
        computed: {
            setStyleLine() {
                console.log(this.label.showMessage);
            }
        }
    }
</script>
<style>
    .labelLoader {
        z-index: 99999;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
    }


    .editLabelContainer {
        width: 65%;
        float: left;
        display: inline-block;
        height: auto;
        padding: 0px 0 0 57px;
    }

    .previewText {
        min-width: 100px;
        height: 43px;
        border-radius: 10px;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
        font-weight: bold;
        font-family: 'SoupBone';
        font-size: 20px;
        letter-spacing: 0.2px;
        text-align: left;
        color: #EA8D00;
        position: relative;
        left: -10px;
        width: auto;
        display: inline-block;
        text-indent: 19px;
        top: -5px;
        line-height: 46px;
    }

    .labelComponent {
        width: 100%;
        display: inline-block;
        position: relative;
    }

    .productname {
        font-family: SoupBone;
        font-size: 50px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #005380;
        padding-bottom: 17px;
    }

    .pallete_colors {
        margin: 0px;
        padding: 0px;
        width: auto;
    }

    #textArea {
        white-space: nowrap;
        position: absolute;
        top: -1500px;
        left: -1500px;
    }

    .startDesign {
        text-align: center;
        color: #ea8d00;
        padding-bottom: 10px;
    }

    .previewMessage {
        padding: 10px;
        text-align: center;
        display: none;
    }

    .previewMessage span {
        color: red;
        width: 100%;
        font-size: 16px;
        font-weight: bold;
    }

    .labelsContainer .page-container .prev {
        z-index: 999;
        border-radius: 10px !important;
        padding: 5px 19px 11px 5px;
    }

    .labelsContainer .page-container .svgPreview.previewContainer.product-images {
        box-shadow: none;
        border-radius: 0px;
        background: #fff;
        overflow: hidden;
    }

    .labelsContainer .page-container .previewComponent.svgPreview {
        height: 100%;
        border-radius:10px;
        overflow: hidden;
    }

    .labelsContainer .svgPreview.previewContainer.product-images .startDesign {
        position: absolute;
        left: 50%;
        bottom: -30px;
        transform: translate(-50%);
    }

    .labelsContainer .page-container .svgPreview.previewContainer.product-images .bacgroundColorsComponent {
        display: block;
    }

    .added-product.svgPreview .a-image {
        border: none;
    }

    .a-related-list .a-related-product{
        margin:0px !important;
        height:100%;
    }
    #lightbox-product{
        height:80%;
    }

    .a-related-list .holder{
        min-height:240px;
    }

    .labelsContainer .svgPreview.previewContainer.product-images .startDesign{
        display:none;
    }

    .labelsContainer .previewContainer.product-images .startDesign.startDesignSvg{
           display:none;
    }
    .labelsContainer .svgPreview.previewContainer.product-images .startDesign.startDesignSvg{
        display: block;
        z-index: 999;
        border-radius: 10px 0 0px 0px !important;
        padding: 5px 19px 11px 5px;
        position: absolute;
        bottom: -5px;
        right: -8px;
        box-shadow: inset 0px 0px 4px 1px rgba(0, 0, 0, 0.5);
        border-radius: 0 0 10px 0;
        padding: 5px 19px 11px 0;
        font-family: 'soupbone', sans-serif;
        font-weight: 700;
        font-size: 20px;
        text-decoration: none;
        color: #ea8d00;
        letter-spacing: 0.2px;
        background: #ffffff;
        transform: none;
        z-index: 9999999999;
        left: unset;
    }

    .startDesign.startDesignSvg span {
        float:left;
        padding: 0 15px;
    }

    .startDesign.startDesignSvg span.icon{

    }

    #lightbox-product .startDesign {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Label.vue